import { useReportForm } from 'modules/reports/hooks/useReportFormContext';
import NextStepButton from '../../components/atoms/next-step-button/NextStepButton';
import { TableHeader } from 'components/organisms/table';
import { reportOverviewHeaderData } from '../../overview/report-overview.function';
import { ReportTableRow } from 'modules/reports/components/organisms/report-table-row/ReportTableRow';
import { useEffect, useState } from 'react';
import styles from './select-clients.module.scss';
import {
  ITableSortLabel,
  Table,
  TableBody,
  TableCell,
  TableSortLabel
} from '@sanlam-glacier/app-common/components';

type Client = {
  id: number;
  clientName: string;
  clientSurname: string;
  investmentType: string;
};

export const SelectClients = () => {
  const { toggleClient } = useReportForm();
  const [order, setOrder] = useState<ITableSortLabel['direction']>(TableSortLabel.DIRECTION.DESC);
  const [orderBy, setOrderBy] = useState<keyof Client>('id');
  const [sortedData, setSortedData] = useState<Client[]>([]);

  const proposalOverviewData: Client[] = [
    {
      id: 1,
      clientName: 'John',
      clientSurname: 'Doe',
      investmentType: 'Stocks'
    },
    {
      id: 2,
      clientName: 'Jane',
      clientSurname: 'Smith',
      investmentType: 'Bonds'
    },
    {
      id: 3,
      clientName: 'Alice',
      clientSurname: 'Brown',
      investmentType: 'Crypto'
    }
  ];

  const handleSort = (propertyName: keyof Client | undefined) => {
    if (!propertyName) return;

    const newOrder =
      propertyName === orderBy
        ? order === TableSortLabel.DIRECTION.ASC
          ? TableSortLabel.DIRECTION.DESC
          : TableSortLabel.DIRECTION.ASC
        : TableSortLabel.DIRECTION.DESC;

    setOrder(newOrder);
    setOrderBy(propertyName);
  };

  useEffect(() => {
    const sorted = [...proposalOverviewData].sort((a, b) => {
      const valueA = a[orderBy];
      const valueB = b[orderBy];

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return order === TableSortLabel.DIRECTION.ASC
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }
      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return order === TableSortLabel.DIRECTION.ASC ? valueA - valueB : valueB - valueA;
      }
      return 0;
    });

    setSortedData(sorted);
  }, [order, orderBy]);

  return (
    <div>
      <Table className={styles.selectClientTable}>
        <TableHeader
          headers={reportOverviewHeaderData}
          orderBy={orderBy}
          align={TableCell.ALIGN.LEFT}
          direction={order}
          handleSort={(propertyName) => handleSort(propertyName as keyof Client)}
          tableHeaderClassName={styles.tableSortHeaderLabel}
        />
        <TableBody>
          {sortedData.map((row) => (
            <ReportTableRow key={row.id} row={row} toggleClient={toggleClient} />
          ))}
        </TableBody>
      </Table>

      <NextStepButton />
    </div>
  );
};
